import MapLibreGL from "maplibre-gl";

type Entry = {
    marker: MapLibreGL.Marker;
    tooltip: MapLibreGL.Popup;
    handleMarkerMouseEnter: () => void;
    handleMarkerMouseLeave: () => void;
};

const registry = new Map<any, Entry>();

function initialize(
    dotNetHelper: any,
    map: MapLibreGL.Map,
    marker: MapLibreGL.Marker,
    tooltipEl: HTMLElement,
    options: MapLibreGL.PopupOptions
): void {
    const tooltip = new MapLibreGL.Popup({
        offset: 16,
        closeButton: false,
        closeOnClick: true,
        ...options
    })
        .setMaxWidth("none")
        .setDOMContent(tooltipEl);

    const handleMarkerMouseEnter = () => tooltip.setLngLat(marker.getLngLat()).addTo(map);
    const handleMarkerMouseLeave = () => tooltip.remove();

    const markerEl = marker.getElement();
    markerEl.addEventListener("mouseenter", handleMarkerMouseEnter);
    markerEl.addEventListener("mouseleave", handleMarkerMouseLeave);

    registry.set(dotNetHelper, {
        marker,
        tooltip,
        handleMarkerMouseEnter,
        handleMarkerMouseLeave
    });
}

function destroy(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const {
        marker,
        tooltip,
        handleMarkerMouseEnter,
        handleMarkerMouseLeave
    } = entry;

    const markerEl = marker.getElement();
    markerEl.removeEventListener("mouseenter", handleMarkerMouseEnter);
    markerEl.removeEventListener("mouseleave", handleMarkerMouseLeave);
    tooltip.remove();

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    destroy
}